import z from 'zod'

// 環境変数名は v1（@mbfab/app-client）から引き継ぎ、Next.js 時代の NEXT_PUBLIC_ プレフィックスを
// 維持している。CodeBuild・開発者ローカルの .env などリポジトリ外の設定と足並みを揃える必要が
// あるため、VITE_ への改名はインフラと同時に行う（vite.config.ts の envPrefix で NEXT_PUBLIC_ を公開）。
// このスキーマは env.ts（ランタイム）と vite.config.ts（ビルド時の設定漏れ検知）の両方から使う。
// v1 と異なり、監視系（Bugsnag/PostHog 等）はカットオーバー前に別途移植するため、
// ここでは v2 が実際に使う項目のみを定義する。
export const publicEnvSchema = z.object({
  NEXT_PUBLIC_API_HOST: z.string(),
  NEXT_PUBLIC_AUTH0_DOMAIN: z.string(),
  NEXT_PUBLIC_AUTH0_SPA_APP_CLIENT_ID: z.string(),
  NEXT_PUBLIC_BUGSNAG_API_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_API_URL: z.string().optional(),
})
